const isPmkinoWebApp = () => {
  const isAndroidApp = navigator.userAgent.search("pmkino-webapp-android")
  const isiOSApp = navigator.userAgent.search("pmkino-webapp-ios")

  return isAndroidApp !== -1 || isiOSApp !== -1
};

export default isPmkinoWebApp;